var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticStyle: { padding: "0px 20px" } },
    [
      _c(
        "div",
        [
          _c(
            "v-tabs",
            {
              attrs: {
                value: _vm.currentTab,
                "fixed-tabs": "",
                "slider-color": "#4fa2b7"
              }
            },
            _vm._l(_vm.tabs, function(tab, index) {
              return _c(
                "v-tab",
                {
                  key: index,
                  staticClass: "custom-tab",
                  attrs: { disabled: "" }
                },
                [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "text-left" }, [
        _c("div", { staticClass: "textContainer" }, [
          _vm.currentTab === 0
            ? _c("div", [_vm._v(_vm._s(_vm.$t("CustomMessageWorkspace")))])
            : _vm.currentTab === 1
            ? _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("CustomMessageBuildings")) +
                    "\n      "
                )
              ])
            : _vm.currentTab === 2
            ? _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("CustomMessageConfiguration")) +
                    "\n      "
                )
              ])
            : _vm.currentTab === 3
            ? _c("div", [_vm._v(_vm._s(_vm.$t("CustomMessagePreview")))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.currentTab !== 0 && _vm.currentTab !== 3
                ? _c(
                    "v-btn",
                    {
                      staticClass: "previousBtn",
                      on: { click: _vm.updateParentTabPrev }
                    },
                    [_vm._v("Previous")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab !== 3
                ? _c(
                    "v-btn",
                    {
                      staticClass: "nextBtn",
                      on: { click: _vm.updateParentTabNext }
                    },
                    [_vm._v("Next")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === 3
                ? _c(
                    "v-btn",
                    {
                      staticClass: "nextBtn",
                      on: { click: _vm.executeHandler }
                    },
                    [_vm._v("Execute")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46dfef3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46dfef3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/Tabs.vue
// module id = null
// module chunks = 